/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import validator from 'validator';
import {
  Card,
  CardTitle,
  CardHeader,
  CardText,
  CardActions,
} from 'material-ui/Card';
import IconButton from 'material-ui/IconButton';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';
import IconMenu from 'material-ui/IconMenu';
import Toggle from 'material-ui/Toggle';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import DeleteIcon from 'material-ui/svg-icons/action/delete-forever';
import Chip from 'material-ui/Chip';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import { database } from '../../utils/configureFirebase';

const registrationPassword = '#EB#Registration';
const editWord = 'MA#EDIT#COLLEGE';
const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const CardIcon = styled.div`
  display: flex;
  align-item: center;
  position: absolute;
  top: 22px;
  right: 40px;
`;

const RedIconBadge = styled.div`
  background: ${props => props.theme.accent1Color};
  color: white;
  border-radius: 24px;
  text-align: center;
  height: 32px;
  width: 32px;
  margin-top: 10px;
  padding-top: 6px;
`;

const BlueIconBadge = styled.div`
  background: ${props => props.theme.primary1Color};
  color: white;
  border-radius: 24px;
  text-align: center;
  height: 32px;
  width: 32px;
  margin-top: 10px;
  padding-top: 6px;
`;

const ContentContainer = styled.div`
  & > * + * {
    margin-top: 16px;
  }
`;

const RegisterationContiner = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const styles = {
  headerStyle: {
    paddingLeft: 0,
  },
  textStyle: {
    paddingTop: 0,
  },
};

const RedBadge = count => <RedIconBadge>{count}</RedIconBadge>;

const BlueBadge = count => <BlueIconBadge>{count}</BlueIconBadge>;

class EarlyBirdCollegeCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openRegistrations: false,
      password: '',
      passwordErrorMessage: undefined,
      showToggle: false,
      editPasswordModal: false,
      editPassword: '',
      editPasswordErrorMessage: undefined,
    };
  }

  openRegistrations = () => {
    this.setState(() => ({
      openRegistrations: true,
      password: '',
      passwordErrorMessage: undefined,
      showToggle: false,
    }));
  };

  closeRegistrations = () => {
    this.setState(() => ({
      openRegistrations: false,
    }));
  };

  confirmRegistrationPassword = () => {
    const { password } = this.state;
    let flag = false;
    if (validator.isEmpty(password)) {
      this.setState(() => ({
        passwordErrorMessage: 'Password is required',
      }));
      flag = true;
    } else if (password !== registrationPassword) {
      this.setState(() => ({
        passwordErrorMessage: 'Password is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        passwordErrorMessage: undefined,
      }));
    }

    if (!flag) {
      this.setState(() => ({
        showToggle: true,
      }));
    }
  };

  changeRegisterationsStatus = (collegeId, value) => {
    database
      .ref()
      .child(`contact/college/${collegeId}`)
      .update({ registerationsOpen: value });
  };

  openEditPasswordModal = () => {
    this.setState(() => ({
      editPasswordModal: true,
    }));
  };

  closeEditPasswordModal = () => {
    this.setState(() => ({
      editPasswordModal: false,
    }));
  };

  moveToEdit = (id) => {
    const { editPassword } = this.state;
    const { history } = this.props;
    if (editPassword === editWord) {
      history.push(`/edit/college/${id}`);
    } else {
      this.setState(() => ({
        editPassword: '',
        editPasswordErrorMessage: 'Incorrect Password',
      }));
    }
  };

  render() {
    const {
      openRegistrations,
      password,
      passwordErrorMessage,
      showToggle,
      editPassword,
      editPasswordErrorMessage,
      editPasswordModal,
    } = this.state;
    const {
      collegeName,
      collegeYear,
      university,
      society,
      address,
      city,
      state,
      collegeId,
      promoterContact,
      principleContact,
      headTPO,
      degrees,
      streams,
      accreditations,
      count,
      registerationsOpen,
    } = this.props;

    // console.log("collegeId============>", collegeId, "promoterContact==========>",promoterContact);
    return (
      <div>
        <Card style={{ position: 'relative' }}>
          <CardIcon>
            {registerationsOpen ? BlueBadge(count) : RedBadge(count)}
            <IconMenu
              iconButtonElement={
                <IconButton>
                  <MoreVertIcon />
                </IconButton>
              }
              targetOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
            >
              <MenuItem
                leftIcon={<EditIcon />}
                primaryText="Edit"
                onTouchTap={() => {
                  this.openEditPasswordModal();
                }}
              />
              <MenuItem leftIcon={<DeleteIcon />} primaryText="Delete" />
            </IconMenu>
          </CardIcon>
          <CardTitle
            title={collegeName}
            subtitle={`${collegeYear} | ${university} | ${society}`}
            titleStyle={{ width: '624px' }}
            actAsExpander
          />
          <CardText expandable style={styles.textStyle}>
            <CardHeader
              title={`${address}, ${city}, ${state}`}
              style={styles.headerStyle}
            />
            <CardTitle
              title="Registration Link"
              style={styles.headerStyle}
              titleStyle={{ fontSize: '20px' }}
            />
            <RegisterationContiner>
              <a
                href={`https://earlybird.myanatomy.in/candidate/${collegeId}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {`https://earlybird.myanatomy.in/candidate/${collegeId}`}
              </a>
            </RegisterationContiner>
            <CardActions style={{ paddingLeft: 0, marginTop: '16px' }}>
              <a
                href={`/campus/data/${collegeId}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <RaisedButton
                  label="View Demographics"
                  primary
                  onTouchTap={() => {
                    // history.push(`/campus/data/${collegeId}`);
                  }}
                />
              </a>
              <FlatButton
                label="Change Status"
                primary
                onTouchTap={() => {
                  this.openRegistrations();
                }}
              />
            </CardActions>
            <CardTitle
              title="Contact Information"
              style={styles.headerStyle}
              titleStyle={{ fontSize: '20px' }}
            />

            <ContentContainer>
              {promoterContact &&
                promoterContact.map(contact => (
                  <Card key={contact.id}>
                    <CardHeader
                      title={`${contact.name} - Chairman`}
                      subtitle={`${contact.email} | ${contact.primaryNum}, ${
                        contact.secondaryNum
                      }`}
                    />
                  </Card>
                ))}
              <Card>
                <CardHeader
                  title={`${principleContact.principleName} - Principle`}
                  subtitle={`${principleContact.principleEmail} | ${
                    principleContact.principlePrimaryNum
                  }, ${principleContact.principleSecondaryNum}`}
                />
              </Card>
              <Card>
                <CardHeader
                  title={`${headTPO.headTpoName} - Head TPO`}
                  subtitle={`${headTPO.headTpoEmail} | ${
                    headTPO.headTpoPrimaryNum
                  }, ${headTPO.headTpoSecondaryNum}`}
                />
              </Card>
            </ContentContainer>

            <CardTitle
              title="Degrees"
              style={styles.headerStyle}
              titleStyle={{ fontSize: '20px' }}
            />
            <ChipsContainer>
              {degrees.map(degree => (
                <Chip
                  style={{
                    marginBottom: 8,
                    marginRight: 8,
                  }}
                  key={degree}
                >
                  {degree}
                </Chip>
              ))}
            </ChipsContainer>

            <CardTitle
              title="Streams"
              style={styles.headerStyle}
              titleStyle={{ fontSize: '20px' }}
            />
            <ChipsContainer>
              {streams.map(stream => (
                <Chip
                  key={stream.id}
                  style={{
                    marginBottom: 8,
                    marginRight: 8,
                  }}
                >
                  {stream.stream}
                </Chip>
              ))}
            </ChipsContainer>

            <CardTitle
              title="Accreditations"
              style={styles.headerStyle}
              titleStyle={{ fontSize: '20px' }}
            />
            <ContentContainer>
              {accreditations.map(accred => (
                <Card key={accred.id}>
                  <CardHeader title={accred.name} subtitle={accred.year} />
                  <CardText>{accred.description}</CardText>
                </Card>
              ))}
            </ContentContainer>
          </CardText>
        </Card>
        <Dialog
          title="Registerations Status"
          actions={
            <FlatButton
              label="Close"
              primary
              onTouchTap={() => {
                this.closeRegistrations();
              }}
            />
          }
          open={openRegistrations}
        >
          <CardText>
            {showToggle ? (
              <div>
                <Toggle
                  label={
                    registerationsOpen
                      ? 'Registrations Open'
                      : 'Registrations Close'
                  }
                  defaultToggled={registerationsOpen}
                  onToggle={(_, toggle) => {
                    this.changeRegisterationsStatus(collegeId, toggle);
                  }}
                  labelPosition="right"
                />
              </div>
            ) : (
              <div>
                <TextField
                  floatingLabelText="Password"
                  hintText="********"
                  value={password}
                  onChange={(_, value) => {
                    this.setState(() => ({
                      password: value,
                    }));
                  }}
                  errorText={passwordErrorMessage}
                />
                <RaisedButton
                  primary
                  label="Submit"
                  style={{ marginLeft: 16 }}
                  onTouchTap={() => {
                    this.confirmRegistrationPassword();
                  }}
                />
              </div>
            )}
          </CardText>
        </Dialog>
        <Dialog
          title="Edit Password"
          actions={[
            <RaisedButton
              label="Submit"
              primary
              onTouchTap={() => {
                this.moveToEdit(collegeId);
              }}
            />,
            <FlatButton
              label="Close"
              primary
              onTouchTap={() => {
                this.closeEditPasswordModal();
              }}
            />,
          ]}
          open={editPasswordModal}
          onRequestClose={this.closeEditPasswordModal}
        >
          <TextField
            floatingLabelText="Password"
            hintText="********"
            type="password"
            value={editPassword}
            onChange={(_, value) => {
              this.setState(() => ({
                editPassword: value,
              }));
            }}
            errorText={editPasswordErrorMessage}
          />
        </Dialog>
      </div>
    );
  }
}

EarlyBirdCollegeCard.propTypes = {
  collegeName: PropTypes.string.isRequired,
  collegeYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  university: PropTypes.string.isRequired,
  society: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  collegeId: PropTypes.string.isRequired,
  promoterContact: PropTypes.array.isRequired,
  principleContact: PropTypes.object.isRequired,
  headTPO: PropTypes.object.isRequired,
  degrees: PropTypes.array.isRequired,
  streams: PropTypes.array.isRequired,
  accreditations: PropTypes.array.isRequired,
  count: PropTypes.number,
  history: PropTypes.object.isRequired,
  registerationsOpen: PropTypes.bool.isRequired,
};

EarlyBirdCollegeCard.defaultProps = {
  count: 0,
};

export default EarlyBirdCollegeCard;



// WEBPACK FOOTER //
// ./src/components/EarlyBirdCollegeCard/EarlyBirdCollegeCard.js